import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CareTypeModal.css';

const CareTypeModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleCareTypeSelect = (careType) => {
    if (careType === 'primary') {
      window.location.href = '/primary-care'; // Full page navigation
    } else if (careType === 'urgent') {
      // Replace with your urgent care route when available
      navigate('/urgent-care');
    }
    onClose();
  };

  const handleClose = (e) => {
    e.stopPropagation();
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <button className="close-modal" onClick={handleClose}>
          &times;
        </button>
        <h2>Choose Care Type</h2>
        <p className="care-instructions">Please select the type of care you need:</p>
        <div className="care-options">
          <button 
            className="care-option urgent"
            onClick={() => handleCareTypeSelect('urgent')}
          >
            <h3>Urgent Care</h3>
            <p>Immediate attention for non-life-threatening conditions</p>
          </button>
          <button 
            className="care-option primary"
            onClick={() => handleCareTypeSelect('primary')}
          >
            <h3>Primary Care</h3>
            <p>Routine check-ups and ongoing care</p>
            <p className="care-option-note">Effective May 4, 2026: Primary Care services end.</p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CareTypeModal;
